export { isAndroidWebView } from "./crmReminderNotifications";

export function canSharePdfViaAndroid() {
  return (
    typeof window !== "undefined" &&
    typeof window.BeentaraAndroid?.shareBlob === "function"
  );
}

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result || "";
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.substring(comma + 1) : result);
    };
    reader.onerror = () =>
      reject(reader.error || new Error("Failed to read file data"));
    reader.readAsDataURL(blob);
  });
}

export async function sharePdfViaAndroid(blob, filename, mimeType = "application/pdf") {
  if (!window.BeentaraAndroid?.shareBlob) {
    throw new Error(
      "Share is not available in this app version. Please update Beentara."
    );
  }
  const base64 = await blobToBase64(blob);
  window.BeentaraAndroid.shareBlob(
    base64,
    mimeType || blob.type || "application/pdf",
    filename
  );
}
